import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { adminFormOptions } from "../shared";

export const NameBlock = withForm({
  ...adminFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>Add New User</FieldLegend>
        <FieldDescription>
          Enter the user's basic identity details, including their first and
          last name, which are used throughout the system for display and
          identification.
        </FieldDescription>

        <FieldGroup>
          <Field orientation="horizontal">
            <Field>
              <form.AppField name="firstName">
                {(field) => <field.TextField label="First name" />}
              </form.AppField>
            </Field>
            <Field>
              <form.AppField name="lastName">
                {(field) => <field.TextField label="Last name" />}
              </form.AppField>
            </Field>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
